<template>
  <div class="cta-block">
    <div class="block-wrapper">
      <div class="block-content">
        <strong>{{ $t("plan.groupCreateBlock.create.upperCase") }}</strong>
        <h2>{{ $t("plan.groupCreateBlock.header") }}</h2>
        <p>{{ $t("plan.groupCreateBlock.text") }}</p>
        <a v-on:click.prevent="showModal = true" class="modal" href="#">{{ $t("plan.groupCreateBlock.create.lowerCase") }}</a>
        <Modal v-if="showModal" v-bind:modalTitle="$t('plan.groupCreateBlock.modal.header')" @close="showModal = false">
          <p>{{ $t("plan.groupCreateBlock.modal.text") }}:</p>
          <GroupForm v-bind:planId="planId"/>
        </Modal>
      </div>
      <div class="block-foot">
        <a class="add" v-on:click.prevent="showModal = true" href="">+</a>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'
import GroupForm from '@/components/plan/GroupForm.vue'

//import { planService } from '@/services/plan.service'

export default {
  props: ['planId'],
  name: 'GroupCreateBlock',
  components: {
    Modal,
    GroupForm
  },
  data () {
    return {
      showModal: false
    }
  },
  created: function () {
    //console.log('planId: ', this.planId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cta-block {
  margin-bottom: 20px;
  flex: 0 1 24%;

  .block-wrapper {
    height: 100%;
    background-color: $secondary;
    color: $text-dark;
    padding: 12px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
  }
}

.block-content {
  flex: 1 0 auto;
  position: relative;
}

.block-foot {
  flex: 0 1 auto;
}

a {
  color: $primary;
  text-decoration: underline;
}

a.modal {
  position: absolute;
  display: block;
  top: 0;
  width: 100%;
  height: 100%;
  text-indent: -9999px;
  white-space: nowrap;
}

h2 {
  color: $primary;
  font-weight: $semi-bold;
}

strong {
  color: $accent;
}

a.add {
  margin-top: 17px;
  line-height: 30px;
  float: right;
  width: 20px;
  height: 20px;
  background: url('../../assets/icons/plus.png') no-repeat center center;
  text-indent: -9999px;
  white-space: nowrap;
  outline: none;
}
</style>
